module.exports = __webpack_public_path__ + "images/drawings/moon/waning-gibbous.21f83700a4ab53724fbec3fdea74b84b.png";